import Vue from 'vue'
import { VuexModule, Module, Mutation, Action } from 'vuex-class-modules'
import {settings} from '@/settings/settings';
import store from '../index'
import {authModule} from "./auth.module";

@Module
class WebsocketConnectionModule extends VuexModule {

    wsHost = ''

    connected = false

    @Mutation
    setWsHost(hostName: string) {
        this.wsHost = hostName
    }

    @Action
    connect(hostName?: string) {
        if (hostName) {
            this.setWsHost(hostName)
        } else if (!this.wsHost) {
            throw Error('WS host is not defined')
        }
        if (!this.connected && authModule.deviceToken) {
            Vue.prototype.$connect(this.wsHost + '?token=' + authModule.deviceToken.value)
        }
    }

    @Action
    disconnect() {
        if (this.connected) {
            Vue.prototype.$disconnect()
        }
    }

    @Action
    reconnect() {
        this.disconnect()
        setTimeout(() => this.connect(), 3000)
    }
}

export const websoketConnectionModule = new WebsocketConnectionModule({ store, name: 'websoketConnectionModule' })